import { z } from "zod";
import i18n from "@/i18n";

const t = (key: string) => i18n.t(key, { ns: "validation" });

// Schema para atualizar perfil do usuário
export const profileSchema = z.object({
  email: z
    .string()
    .trim()
    .email({ message: t("emailInvalid") })
    .max(255, { message: t("emailTooLong") }),
  full_name: z
    .string()
    .trim()
    .min(2, { message: t("nameMin") })
    .max(100, { message: t("nameTooLong") }),
  phone: z
    .string()
    .trim()
    .regex(/^[\d\s\-()+]*$/, { message: t("phoneInvalid") })
    .optional()
    .or(z.literal("")),
  crmv_state: z
    .string()
    .trim()
    .max(2, { message: t("stateInvalid") })
    .optional()
    .or(z.literal("")),
  crmv_number: z
    .number()
    .int({ message: t("crmvInt") })
    .positive({ message: t("crmvPositive") })
    .optional()
    .or(z.null()),
  mapa_number: z
    .string()
    .trim()
    .max(50, { message: t("mapaTooLong") })
    .optional()
    .or(z.literal("")),
  address: z
    .string()
    .trim()
    .max(300, { message: t("addressTooLong") })
    .optional()
    .or(z.literal("")),
  cpf: z
    .string()
    .trim()
    .regex(/^[\d.-]*$/, { message: t("cpfInvalid") })
    .optional()
    .or(z.literal("")),
});

export type ProfileInput = z.infer<typeof profileSchema>;
